'use client';

import style from "./HeroProgramSectionSliders.module.scss";
import ProgramCards from "./ProgramCards";
import UnivoCarousel from "@/components/common/UnivoCarousel";
import UnivoLink from "@/components/common/UnivoLink";
import { pushToDataLayer } from "@/helpers/gtag";

const fireGTEvents = ({ program_name }) => {
  pushToDataLayer({
    event: "program_card_clicked",
    section_name: "hero_banner",
    program_name: program_name,
    page_url: window?.location?.href
  });
};

const HeroProgramSectionSliders = ({sliderData}) => {
  return (
    <div className={style.root}>
      <UnivoCarousel
        preset="heroPrograms"
        className={style.swiper_container}
        slideWrapperClassName={style.slide}
      >
        {
          sliderData?.map((item, index) => {
            return (
              <UnivoLink
                href={item?.slug?.trim() || "/"}
                className={style.card_link}
                key={index}
                id={`banner-program-${item.id}`}
                onClick={() =>
                  fireGTEvents({
                    program_name: item?.Title,
                  })
                }
              >
                <ProgramCards
                  programName={item?.Title}
                  subText={item?.SubTitle}
                  imgSrc={item?.Image}
                  slug={item?.slug?.trim()}
                  isLazy={index >= 4}
                  isLcp={false}
                />
              </UnivoLink>
            );
          })
        }
      </UnivoCarousel>
    </div>
  )
}

export default HeroProgramSectionSliders;
